import AddToBasketButton from 'components/AddToBasketButton/AddToBasketButton';
import { withAddToBasketButtonProps } from 'viewModel/addToBasketButton/withAddToBasketButtonProps';

export default withAddToBasketButtonProps(AddToBasketButton);
